<script setup lang="ts">
import { useAdminListSalesSubscriptionPlans } from '@swipe4work/api-orval'

const props = defineProps<{
  modelValue: number | null
  inputId?: string
  invalid?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', v: number | null): void
}>()

const { data, isPending } = useAdminListSalesSubscriptionPlans({ query: { staleTime: Infinity } })

const plans = computed(() => data.value?.plans ?? [])

const selected = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
})
</script>

<template>
  <Select
    v-model="selected"
    :input-id="inputId"
    :options="plans"
    option-label="title"
    option-value="id"
    :invalid="invalid"
    :loading="isPending"
    placeholder="Selecteer abonnement"
    show-clear
    class="w-full"
  />
</template>
